import { createSelector } from '@reduxjs/toolkit';
import { createInputBindings } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { createOptionBindings } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { ColorAttributeInput } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeInput';
import { ColorAttributeOptions } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';

const { createInputSelector, createInputUpdater }
    = createInputBindings<ColorAttributeInput>();

export const selectValueById = createInputSelector(i => i.value);
export const updateValueByIds = createInputUpdater('value');

const { createOptionSelector } = createOptionBindings<ColorAttributeOptions>();

export const selectColorChoicesById = createOptionSelector(i => i.choices);
export const selectComponentById = createOptionSelector(i => i.component);

export const selectChosenColorById = createSelector([
    selectColorChoicesById,
    selectValueById
], (choices, value) => {
    return choices!.find(c => c.value === value!)!;
});